
import React from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import VideocamIcon from '@mui/icons-material/Videocam';

const ApplicantCard = ({ item }) => {
    const { image, name, profile, age, experience, location, appliedFor } = item;

    return (
        <Grid item md={6} xs={12} >
            <Card variant="outlined" sx={{ flex: '1 0 auto', objectFit: 'contain', backgroundColor: 'rgba(139, 172, 248, 0.05)' }}>
                <CardContent sx={{ display: 'flex',flexDirection:{md:'row', xs:'column'}, verticalAlign: 'center' }} >
                    <img src={image} width={180} height={190} style={{ border: '1px', borderRadius: 13, verticalAlign: 'center' }} />
                    <Box sx={{ marginInline: 2 }}>
                        <Typography className='subHeading1Bold' >{name}</Typography>
                        <Typography className='text1Mid' sx={{ pt: 1.5 }}>{profile} | {age}</Typography>
                        <Typography className='text1Mid' sx={{ pt: 1 }}>{experience} Years Experience</Typography>
                        <Typography className='text1Mid' sx={{ pt: 1 }}>{location}</Typography>
                        <Box sx={{ display: 'flex' }}>
                            <Typography className='text1Bold' sx={{ pt: 1 }}>Appliend For:</Typography>
                            <Typography className='text1Mid' sx={{ pt: 1 }}>{appliedFor}</Typography>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'block' }}>
                        <button className="applicantButton" onClick={() => alert('Button Clicked!')}>Schedule Interview <VideocamIcon /></button>
                        <button className="applicantButton">Notify Candidate </button>
                    </Box>
                </CardContent>
            </Card>
        </Grid>
    );
}

export default ApplicantCard;